export const environment = {
  production: false,
  apiUrl: 'http://localhost:8081', // Backend URL
  wsUrl: 'http://localhost:8081/ws', // WebSocket URL (SockJS needs HTTP, not WS)
  appName: 'Sistema de Secretaría General',
  version: '1.0.0'
};